import styled, { css } from 'styled-components';

import DurationMiniVacation from '@lt/components/icons-react/DurationMiniVacation';
import DurationOneWeek from '@lt/components/icons-react/DurationOneWeek';
import DurationTenDays from '@lt/components/icons-react/DurationTenDays';
import DurationTwoWeeks from '@lt/components/icons-react/DurationTwoWeeks';
import CalendarDay from '@lt/components/icons-react/userflow/CalendarDay';

const nightsPresetIconStyles = css`
  width: 16px;
  height: 16px;
`;

const DurationMiniVacationIcon = styled(DurationMiniVacation)`
  ${nightsPresetIconStyles}
`;

const DurationOneWeekIcon = styled(DurationOneWeek)`
  ${nightsPresetIconStyles}
`;

const DurationTenDaysIcon = styled(DurationTenDays)`
  ${nightsPresetIconStyles}
`;

const DurationTwoWeeksIcon = styled(DurationTwoWeeks)`
  ${nightsPresetIconStyles}
`;

const CalendarDayIcon = styled(CalendarDay)`
  ${nightsPresetIconStyles}
`;

export const NIGHTS_PRESET_NAME_TO_ICON = {
  nights_interval: CalendarDayIcon,
  mini: DurationMiniVacationIcon,
  week: DurationOneWeekIcon,
  ten_nights: DurationTenDaysIcon,
  two_weeks: DurationTwoWeeksIcon,
};
